import Config from "../../../core/config/Config";
import DebugModel from "../../debug/model/DebugModel";
import PlatformUserModel from "../model/PlatformUserModel";

export default class MockPlatformUserService {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {Config} config 
     * @param {PlatformUserModel} platformUserModel 
     */
    constructor(dispatcher, config, platformUserModel) {
        this._dispatcher = dispatcher;
        this._config = config;
        this._platformUserModel = platformUserModel;
    }

    /**
     * Set the access token for authenticated requests
     * @param {string} token 
     */
    setAccessToken(token) {

    }

    /**
     * Get current learner's name.
     * @returns {Promise<string>}
     */
    async getName() {
        return DebugModel.playerName || "Speler";
    }

    /**
     * Put a score for the current learner.
     * @param {Object} params
     * @param {string} params.groupSpirit 
     * @param {string} params.trust
     */
    async putScore({ groupSpirit, trust }) {
        console.log(`[${MockPlatformUserService.name}] putScore`, { groupSpirit, trust });
    }

    /**
     * Get completion status for the current learner.
     * @returns {Promise<{status: "not started"|"incompleted"|"completed"}>}
     */
    async getCompletionStatus() {
        return { status: "not started" };
    }

    /**
     * Set completion status for the current learner.
     * @param {Object} params
     * @param {"not_started"|"incompleted"|"completed"} params.completionStatus
     */
    async setCompletionStatus({ completionStatus }) {
        console.log(`[${MockPlatformUserService.name}] setCompletionStatus`, { completionStatus });
    }

    /**
     * Read savegame data for the current learner
     * @returns {Promise<{savegameId: string, data: Object, version: string, createdAt: string, updatedAt: string}>}
     */
    async getSavegame() {
        console.log(`[${MockPlatformUserService.name}] getSavegame - ignoring this request.`);
    }

    /**
     * Set savegame data for the current learner.
     * @param {Object} params
     * @param {Object} params.savegame The savegame data object (serialized JSON)
     */
    async setSavegame({ savegame }) {
        console.log(`[${MockPlatformUserService.name}] setSavegame - ignoring this request.`, savegame);
    }

    /**
     * Delete savegame data for the current learner.
     */
    async deleteSavegame() {
        console.log(`[${MockPlatformUserService.name}] deleteSavegame - ignoring this request.`);
    }

    /**
     * Puts a conversation summary.
     * @param {Object} params
     * @param {string} params.conversationId Unique conversation identifier.
     * @param {string} params.summary Summary text.
     * @param {Array<{quote: string, feedback: string}>} params.feedbackItems Feedback items from the conversation.
     */
    async putConversationResult({ conversationId, summary, feedbackItems }) {
        console.log(`[${MockPlatformUserService.name}] putConversationResult - ignoring this request.`, { conversationId, summary, feedbackItems });
    }

    /**
     * Puts a reflection summary.
     * @param {Object} params
     * @param {string} params.reflectionId Unique reflection identifier.
     * @param {string} params.summary Summary text.
     */
    async putReflectionResult({ reflectionId, summary }) {
        console.log(`[${MockPlatformUserService.name}] putReflectionResult - ignoring this request.`, { reflectionId, summary });
    }

    async patchCompleteGameSession({ sessionId }) {
        console.log(`[${MockPlatformUserService.name}] patchCompleteGameSession - ignoring this request.`, { sessionId });
    }
}